import { useEffect, useState, useRef } from "react";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import history from "../../../history";
import "react-confirm-alert/src/react-confirm-alert.css";
import FormikControl from "../../../layouts/Input/FormikControl";
import ExcelIcon from "../../../assets/Images/Distributors/excel-icon.png";
import {
  Modal,
  Col,
  Row,
  Overlay,
  Button,
  Popover,
  Container,
} from "react-bootstrap";
import { connect } from "react-redux";
import { getRsoJobs, resetDropdownList } from "./OnBoardingShopsAction";
import {
  GET_RSOS_DDL,
  GET_DISTRIBUTOR_DDL,
  GET_JOBS_DISTRIBUTOR_DDL,
  GET_DISTRIBUTIONCENTER_DDL,
  GET_ADDJOB_DISTRIBUTIONCENTER_DDL,
  GET_CITIES,
} from "../../../Types";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import CustomDataTable from "../../../layouts/DataTables/CustomDataTable";
import JobsDataFileTemplate from "../../../assets/Templates/JobTemplate.xlsx";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import storage from "../../../apis/Storage";

const OnBoardingShops = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));

  const addJobFormValidationSchema = Yup.object().shape({
    distributorName: Yup.string().required("Distributor Name is required"),
    distributionCenter: Yup.string().required(
      "Distribution Center is required"
    ),
  });
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const todayDate = new Date();
  const monthStartDate = new Date(todayDate);
  monthStartDate.setDate(monthStartDate.getDate() - 8);
  const [filterRsoName, setFilterRsoName] = useState(null);
  const [filterDistributorName, setFilterDistributorName] = useState(null);
  const [filterDistributionCenter, setFilterDistributionCenter] =
    useState(null);
  const [FilterStatus, setFilterStatus] = useState(null);

  const [cityValue, setCityValue] = useState(null);
  const [dataSheetSelectedFile, setDataSheetSelectedFile] = useState(null);
  const [addJobDistributorName, setAddJobDistributorName] = useState(null);
  const [addJobDistributionCenter, setAddJobDistributionCenter] =
    useState(null);
  const [addJobDistributorsOptions, setAddJobDistributorsOptions] =
    useState(null);
  const [
    addOrderDistributionCentersOptions,
    setAddOrderDistributionCentersOptions,
  ] = useState(null);
  const [jobModalShow, setJobModalShow] = useState(false);

  const [filterValuesModal, setFilterValuesModal] = useState({
    rsoName: "",
    distributorName: "",
    distributionCenter: "",
    fromDate: monthStartDate,
    toDate: todayDate,
    status: "",
    city: "",
  });

  const [addJobModalInitialValue, setAddJobModalInitialValue] = useState({
    distributorName: "",
    distributionCenter: "",
    jobDataFile: null,
  });

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
    props.getDropdownList(`api/User/GetRSODDL`, GET_RSOS_DDL);
    props.getDropdownList(
      `api/DistShopInductionJob/GetDistributorsDDL`,
      GET_JOBS_DISTRIBUTOR_DDL
    );
    if (props.cities.length == 0) {
      props.getDropdownList(`api/City`, GET_CITIES);
    }

    let requestData = {
      FromDate: monthStartDate,
      ToDate: todayDate,
    };
    if (userRights != null && userRights?.userType == "DistributorUser") {
      requestData = {
        ...requestData,
        assignedDistCenters: userRights?.distCenterIds,
      };
    }

    props.getRsoJobs(requestData);
  }, []);
  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId
      );
      setAddJobDistributorsOptions(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setAddJobDistributorsOptions(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distCenterList = props.distCentersddlList.filter((x) =>
        userRights?.distCenterIds.includes(x.value)
      );
      setAddOrderDistributionCentersOptions(
        distCenterList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else {
      setAddOrderDistributionCentersOptions(
        props.distCentersddlList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.distCentersddlList]);

  useEffect(() => {
    if (filterDistributorName) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        {distributorIds: filterDistributorName.value},
        GET_DISTRIBUTIONCENTER_DDL
      );
    }
  }, [filterDistributorName]);
  useEffect(() => {
    if (addJobDistributorName) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        {distributorIds: addJobDistributorName.value},
        GET_ADDJOB_DISTRIBUTIONCENTER_DDL
      );
    }
  }, [addJobDistributorName]);

  const jobStatusList = [
    {
      value: "New",
      label: "New",
    },
    {
      value: "In Progress",
      label: "In Progress",
    },
    {
      value: "Complete",
      label: "Complete",
    },
  ];
  const columns = [
    {
      Header: "RSO",
      accessor: "rsoName",
    },
    {
      Header: "Job No.",
      accessor: "jobNo",
      sortType: "basic",
    },
    {
      Header: "Distributor",
      accessor: "distributorName",
    },
    {
      Header: "Dist. Center",
      accessor: "distCenterName",
    },
    {
      Header: "Job Status",
      accessor: "jobStatus",
    },
    {
      Header: "Completed Shops",
      accessor: "completeShops",
    },
    {
      Header: "Pending Shops",
      accessor: "pendingShops",
    },
  ];
  const citiesOptions = [
    { value: "Lahore", label: "Lahore" },
    { value: "Karachi", label: "Karachi" },
    { value: "Islamabad", label: "Islamabad" },
  ];
  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };
  const LoadDataByfilter = (event) => {
    let requestData = {
      DistributorId: event.distributorName == "" ? null : event.distributorName,
      DistCenterId:
        event.distributionCenter == "" ? null : event.distributionCenter,
      FromDate: event.fromDate,
      ToDate: event.toDate,
      Status: event.status == "" ? null : event.status,
      City: event.city == "" ? null : event.city,
      RSOId: event.rsoName == "" ? null : event.rsoName,
    };

    if (userRights != null && userRights?.userType == "DistributorUser") {
      requestData = {
        ...requestData,
        assignedDistCenters: userRights?.distCenterIds,
      };
    }

    props.getRsoJobs(requestData);
    setShow(false);
  };
  // const OpenModelForAddJob = (isOpen) => {
  //   setJobModalShow(isOpen)
  //   setAddJobModalInitialValue({
  //     rsoName: '',
  //     distributorName: '',
  //     distributionCenter: '',
  //   })
  //   setDataSheetSelectedFile(null)
  //   setShow(false)
  //   setAddJobDistributionCenter(null)
  //   setAddJobDistributorName(null)
  // }
  const submitJobData = () => {
    if (
      dataSheetSelectedFile != null &&
      addJobDistributorName &&
      addJobDistributionCenter
    ) {
      props.addJob({
        distributorId: addJobDistributorName.value, //data.distributorId,
        DistCenterId: addJobDistributionCenter.value,
        DataFile: dataSheetSelectedFile,
      });
      setJobModalShow(false);
    } else {
      toast.error("Please select Job Data Sheet");
    }
  };

  const validateDataSheetFile = (event) => {
    const image = event.target.files[0];
    if (!image) {
      event.target.value = null;
      return;
    }
    if (!image.name.match(/\.(xlsx|xls)$/)) {
      toast.error("You can only upload file of type (xlsx, xls)");
      event.target.value = null;
      return;
    } else {
      setDataSheetSelectedFile(event.target.files[0]);
      addJobModalInitialValue.jobDataFile = event.target.files[0];
    }
  };
  const onRowClick = (e, rowData) => {
    history.push(`/RsoJobDetails/${rowData.inductionJobId}/${rowData.rsoId}`);
    history.go(`/RsoJobDetails/${rowData.inductionJobId}/${rowData.rsoId}`);
  };
  const handleResetFilters = (resetForm) => {
    resetForm();
    setFilterRsoName(null);
    setFilterDistributorName(null);
    setFilterDistributionCenter(null);
    setCityValue(null);
    setFilterStatus(null);
    setFilterValuesModal({
      rsoName: "",
      distributorName: "",
      distributionCenter: "",
      fromDate: monthStartDate,
      toDate: todayDate,
      status: "",
      city: "",
    });
    props.resetDropdownList();
  };
  return (
    <div>
      <VzPageContainer title="Shops On-Boarding Details">
        <Row>
          <Col md={{ span: 3 }} style={{ float: "left" }}>
            <h4>
              <b>Shops On-Boarding Details</b>
            </h4>
          </Col>
          <Col md={{ span: 3, offset: 6 }} style={{ float: "right" }}>
            <div className="form-group">
              {/* <Button
                className='form-btn pull-left'
                variant='primary'
                style={{ float: 'right', margin: '1px 0px 0px 0px' }}
                onClick={() => OpenModelForAddJob(true)}
              >
                <i className='fa fa-tasks' /> Add RSO Job
              </Button> */}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} style={{ float: "right" }}>
            <Row>
              <Col md={3} style={{ float: "right" }}>
                <div ref={ref}>
                  <Button
                    onClick={openFilterModal}
                    className="m-3"
                    variant="outline-primary"
                  >
                    <i className="fa fa-filter" />
                    Filters
                  </Button>

                  <Overlay
                    show={show}
                    target={target}
                    placement="bottom"
                    container={ref}
                    containerPadding={20}
                    width="430px"
                    style={{ width: "430px" }}
                  >
                    <Popover id="popover-contained" width="400">
                      <Popover.Header as="h3">Filters</Popover.Header>
                      <Popover.Body>
                        <Formik
                          enableReinitialize
                          initialValues={filterValuesModal}
                          validator={() => ({})}
                          onSubmit={LoadDataByfilter}
                        >
                          {(formik) => (
                            <Form autoComplete="off">
                              <Row>
                                <Col xs={12} md={12}>
                                  <FormikControl
                                    formik={formik}
                                    control="react-select"
                                    label="RSO Name"
                                    name="rsoName"
                                    options={props.rsosList}
                                    isSearchable={true}
                                    handleOnChange={(e) => {
                                      if (!e || !e.value) {
                                        return;
                                      }
                                      filterValuesModal.rsoName = e.value;
                                      setFilterRsoName({
                                        label: e.label,
                                        value: e.value,
                                      });
                                    }}
                                    value={filterRsoName}
                                  />
                                </Col>
                                <Col xs={12} md={12}>
                                  <FormikControl
                                    formik={formik}
                                    control="react-select"
                                    label="Distributor Name"
                                    name="distributorName"
                                    options={addJobDistributorsOptions}
                                    isSearchable={true}
                                    handleOnChange={(e) => {
                                      if (!e || !e.value) {
                                        return;
                                      }
                                      filterValuesModal.distributorName =
                                        e.value;
                                      setFilterDistributorName({
                                        label: e.label,
                                        value: e.value,
                                      });
                                      setFilterDistributionCenter(null);
                                    }}
                                    value={filterDistributorName}
                                  />
                                </Col>
                                <Col xs={12} md={12}>
                                  <FormikControl
                                    formik={formik}
                                    control="react-select"
                                    label="Distribution Center"
                                    name="distributionCenter"
                                    options={addOrderDistributionCentersOptions}
                                    isSearchable={true}
                                    handleOnChange={(e) => {
                                      if (!e || !e.value) {
                                        return;
                                      }
                                      filterValuesModal.distributionCenter =
                                        e.value;
                                      setFilterDistributionCenter({
                                        label: e.label,
                                        value: e.value,
                                      });
                                    }}
                                    value={filterDistributionCenter}
                                  />
                                </Col>
                                <Row style={{ paddingRight: 0 }}>
                                  <Col xs={12} md={6}>
                                    <FormikControl
                                      // formik={formik}
                                      control="date"
                                      label="From Date"
                                      name="fromDate"
                                      handleOnChange={(value) => {
                                        filterValuesModal.fromDate = value;
                                      }}
                                      value={filterValuesModal.fromDate}
                                    />
                                  </Col>
                                  <Col xs={12} md={6}>
                                    <FormikControl
                                      // formik={formik}
                                      control="date"
                                      // type='date'
                                      label="To Date"
                                      name="toDate"
                                      handleOnChange={(value) => {
                                        filterValuesModal.toDate = value;
                                      }}
                                      value={filterValuesModal.toDate}
                                    />
                                  </Col>
                                </Row>
                                <Col xs={12} md={12}>
                                  <div className="form-group">
                                    <FormikControl
                                      // formik={formik}
                                      control="react-select"
                                      label="Status"
                                      name="status"
                                      options={jobStatusList}
                                      handleOnChange={(e) => {
                                        if (!e || !e.value) {
                                          return;
                                        }
                                        setFilterStatus({
                                          label: e.value,
                                          value: e.value,
                                        });
                                        filterValuesModal.status = e.value;
                                      }}
                                      value={FilterStatus}
                                    />
                                  </div>
                                </Col>
                                <Col xs={12} md={12}>
                                  <div className="form-group">
                                    <FormikControl
                                      // formik={formik}
                                      control="react-select"
                                      label="City"
                                      name="city"
                                      options={props.cities}
                                      isSearchable={false}
                                      handleOnChange={(e) => {
                                        if (!e || !e.value) {
                                          return;
                                        }
                                        setCityValue({
                                          label: e.value,
                                          value: e.value,
                                        });
                                        filterValuesModal.city = e.value;
                                      }}
                                      value={cityValue}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <div className="row">
                                <div className="form-group">
                                  <Link
                                    onClick={handleResetFilters.bind(
                                      null,
                                      formik.resetForm
                                    )}
                                    to="#"
                                    className="active"
                                    style={{
                                      padding: "0px",
                                      marginTop: "10px",
                                      float: "left",
                                    }}
                                  >
                                    Reset
                                  </Link>
                                  <Link
                                    onClick={() => {
                                      setShow(false);
                                      setTarget(null);
                                    }}
                                    to="#"
                                    className="active"
                                    style={{
                                      padding: "0px",
                                      marginTop: "10px",
                                      float: "right",
                                    }}
                                  >
                                    Cancel
                                  </Link>
                                  <div className="float-right">
                                    <Button
                                      type="submit"
                                      className="btn btn-primary"
                                      style={{
                                        marginRight: "10px",
                                        float: "right",
                                      }}
                                    >
                                      Apply
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </Popover.Body>
                    </Popover>
                  </Overlay>
                </div>
              </Col>
            </Row>
            <CustomDataTable
              data={props.rsoJobsList}
              columns={columns}
              getTrProps={(event, data) => onRowClick(event, data)}
            />
          </Col>
        </Row>
        {/* //// Upload Job Data Sheet */}
        <Modal
          show={jobModalShow}
          onHide={() => setJobModalShow(false)}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Add New RSO Jobs
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Formik
              enableReinitialize
              initialValues={addJobModalInitialValue}
              validationSchema={addJobFormValidationSchema}
              // validator={() => ({})}
              onSubmit={submitJobData}
            >
              {(formik) => (
                <Form
                  autoComplete="off"
                  encType="multipart/form-data"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <Container>
                    <Row>
                      <Col md={{ span: 5 }} style={{ float: "right" }}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            control="react-select"
                            label="Distributor"
                            name="distributorName"
                            options={addJobDistributorsOptions}
                            handleOnChange={(option) => {
                              if (!option || !option.value) {
                                setAddJobDistributorName(null);
                                addJobModalInitialValue.distributorName = "";
                              } else {
                                setAddJobDistributorName(option);
                                addJobModalInitialValue.distributorName =
                                  option.label;
                              }
                            }}
                            value={addJobDistributorName}
                          />
                        </div>
                      </Col>
                      <Col md={{ span: 7 }} style={{ float: "right" }}>
                        <div className="form-group">
                          <FormikControl
                            formik={formik}
                            control="react-select"
                            // isSearchable={true}
                            // isClearable={true}
                            label="Distribution Center"
                            name="distributionCenter"
                            options={addOrderDistributionCentersOptions}
                            handleOnChange={(option) => {
                              if (!option || !option.value) {
                                setAddJobDistributionCenter(null);
                                addJobModalInitialValue.distributionCenter = "";
                              } else {
                                setAddJobDistributionCenter(option);
                                addJobModalInitialValue.distributionCenter =
                                  option.value;
                              }
                            }}
                            value={addJobDistributionCenter}
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={{ span: 5 }}>
                        <label style={{ width: "100%" }}>
                          <b>Principal:</b>
                          {addJobDistributionCenter
                            ? addJobDistributionCenter.principalName
                            : "Not Selected"}
                        </label>
                        <label style={{ width: "100%" }}>
                          <b>City Name:</b>
                          {addJobDistributionCenter
                            ? addJobDistributionCenter.cityName
                            : "Not Selected"}
                        </label>
                      </Col>
                      <Col xs={12} md={{ span: 7, offset: 0 }}>
                        <div className="form-group">
                          <div>
                            <div>
                              Select RSO Job Data Sheet File (Only Excel file)
                            </div>
                            {dataSheetSelectedFile && (
                              <div>
                                <img
                                  style={{ border: "1px solid #ccc" }}
                                  alt="not fount"
                                  width={"100px"}
                                  height={"100px"}
                                  src={ExcelIcon}
                                />
                                <br />
                                <button
                                  className="btn btn-info"
                                  style={{
                                    marginLeft: "10px",
                                    marginTop: "10px",
                                    marginBottom: "20px",
                                  }}
                                  onClick={() => {
                                    addJobModalInitialValue.jobDataFile = null;
                                    setDataSheetSelectedFile(null);
                                  }}
                                >
                                  <i className="fa fa-close" />
                                  Remove
                                </button>
                              </div>
                            )}
                            {!dataSheetSelectedFile && (
                              <div>
                                <br />
                                <input
                                  type="file"
                                  name="dataSheetSelectedFile"
                                  onChange={(event) =>
                                    validateDataSheetFile(event)
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={{ span: 5 }}></Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={12}>
                        <Button
                          className="btn btn-default"
                          style={{ float: "right", marginTop: "10px" }}
                          onClick={() => setJobModalShow(false)}
                        >
                          Cancel
                        </Button>
                        <input
                          type="submit"
                          className="btn btn-primary"
                          style={{
                            marginRight: "10px",
                            marginTop: "10px",
                            float: "right",
                          }}
                          value="Save Job"
                        />

                        <a
                          href={`${JobsDataFileTemplate}`}
                          download="JobsTemplateFile"
                          className="active"
                          style={{
                            padding: "0px",
                            marginTop: "20px",
                            float: "left",
                          }}
                        >
                          Download Template
                        </a>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],
    filteredDistributorList: state.ddlList.filteredDistributorList
      ? state.ddlList.filteredDistributorList.filter((el) => {
          return state.rsoJobsList.some((f) => {
            return f.distributorId === el.value;
          });
        })
      : [],
    rsosList: state.ddlList.rsosList
      ? state.ddlList.rsosList.filter((el) => {
          return state.rsoJobsList.some((f) => {
            return f.rsoId === el.value;
          });
        })
      : [],
    distCentersddlList: state.ddlList.selectedDistCentersList
      ? state.ddlList.selectedDistCentersList
      : [],
    addJobDistCentersddlList: state.ddlList.selectedAddJobDistCentersList
      ? state.ddlList.selectedAddJobDistCentersList
      : [],
    rsoJobsList: state.rsoJobsList ? state.rsoJobsList : [],
    cities: state.ddlList.cities ? state.ddlList.cities : [],
  };
};
export default connect(mapStateToProps, {
  resetDropdownList,
  getRsoJobs,
  getDropdownList,
  getDropdownListByPost,
})(OnBoardingShops);
